import { useRecoilValue } from "recoil";
import { CurrentReservationType } from "../../../../../api/reservation";
import { useReservation } from "../../hooks/use-reservation";
import { ReservationOptionButtonWrapper } from "../option/style";
import {
  ReservationConfirmContent,
  ReservationConfirmInfo,
  ReservationConfirmWrapper,
} from "./style";
import { userState } from "../../../../../recoil/auth";

export interface ReservationConfirmProps {
  onClose: () => void;
  hook: ReturnType<typeof useReservation>;
}

const ReservationConfirmModal = ({
  onClose,
  hook,
}: ReservationConfirmProps) => {
  const { type, handleReservation, reservation } = hook;
  const user = useRecoilValue(userState);
  const isSeed = type === CurrentReservationType.SEED;

  return (
    <ReservationConfirmWrapper>
      <ReservationConfirmContent>
        <div className="name">{isSeed ? "보유 래빗" : "보유 매장이용권"}</div>
        <div className="value">
          {isSeed
            ? `${user?.seed} Rabbit`
            : `${(reservation?.point || 0) / 10000} E`}
        </div>
      </ReservationConfirmContent>
      <ReservationConfirmInfo>
        <div className="title">해당 토너먼트를 예약 하시겠습니까?</div>
        <div className="info">
          *{isSeed ? "통합크레딧" : "매장이용권"}{" "}
          {(reservation?.buyIn || 0) / 10000}
          {isSeed ? "RABBIT" : "E"}만큼 차감됩니다.
        </div>
      </ReservationConfirmInfo>
      <ReservationOptionButtonWrapper>
        <div className="button" onClick={onClose}>
          아니오
        </div>
        <div
          className="button purple"
          onClick={() => {
            handleReservation();
            onClose();
          }}
        >
          예
        </div>
      </ReservationOptionButtonWrapper>
    </ReservationConfirmWrapper>
  );
};

export default ReservationConfirmModal;
